import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import { addCartItem } from '../store/cartReducer';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from 'react-router-dom';
const ProductGrid = (props) => {

    const product = props.data;
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const storeProductData = {
        quantity: 1,
        productId: product._id?.toString(),
        imageId: product.image,
        name: product.name,
        owner: product.owner,
        price: product.price,
        sellerId: product.sellerId,
        sku: product.sku,
    }

    const handleAddToCart = () => {
        setIsLoading(true);
        dispatch(addCartItem(storeProductData));


        setTimeout(() => {
            setIsLoading(false);
            toast.success("Item added to cart successfully!");
        }, 100);
    };
    return (
        <div className="col-lg-4 col-md-6 text-center">
            <div className="single-product-item">
                <div className="product-image">
                    <Link to="/"><img src={`${product.image}`} alt="" /></Link>
                </div>
                <h3>{product.name}</h3>
               {product.stock?.toString() !== "0"?<h5>In Stock: {product.stock?.toString()}</h5>:''} 
                <p className="product-price"> {product.price} Eth </p>
                {
                    product.stock?.toString() == "0"? (
                        <button type="button" class="cart-btn btn btn-danger">Out of Stock</button>
                    ):<Link  className="cart-btn" disabled={isLoading} onClick={handleAddToCart}><i className="fas fa-shopping-cart"></i>
                    {isLoading ? (
                        <span className="spinner-border spinner-border-sm" role="status" />
                    ) : (
                        <>
                            Add to Cart <i className="bi bi-cart-plus" />
                        </>
                    )}
                </Link>
                }
                
            </div>
        </div>
    )
}

export default ProductGrid
